// extracted by mini-css-extract-plugin
module.exports = {"container":"home_big_title-module--container--3Pz6v","title":"home_big_title-module--title--25L6y","subtitle":"home_big_title-module--subtitle--CBxdb"};